import React, { useCallback, useState } from 'react'
import withPage from 'server/withPage'
import { setUIState } from 'redux/modules/ui'
import { bindActionCreators } from 'redux'
import PasswordResetEdit from 'components/pages/PasswordResetEditPage'

/**
 * @type {React.FC<{
 *  ui: any,
 *  actions: {
 *   setUIState: Function,
 *  },
 *  config: any,
 *  restClient: {
 *    patch: (path: string, params: Record<string, unknown>) => Promise<any>,
 *  },
 * }>}
 */
const Container = props => {
  const { restClient } = props
  const [isLoading, setIsLoading] = useState(false)
  const [isSend, setIsSend] = useState(false)
  const [errorMessages, setErrorMessage] = useState([])
  const updatePassword = useCallback(
    async ({ password, passwordConfirmation }) => {
      setIsLoading(true)
      const resetPasswordToken = new URLSearchParams(
        window.location.search,
      ).get('reset_password_token')
      try {
        // 共通のヘッダーを変更してしまっているが、ここ以外でrest使わないので問題ない
        restClient.headers.accept = 'application/json'
        await restClient
          .patch('i/password', {
            password,
            password_confirmation: passwordConfirmation,
            reset_password_token: resetPasswordToken,
          })
          .catch(e => {
            // 302の場合は成功とみなす
            if (e?.response?.status !== 302) {
              throw e
            }
          })
        setIsSend(true)
      } catch (e) {
        // TODO: mp_backendへ切り替えた後 errors で返ることは無くなるので判定削除する
        const keyNames = {
          password: 'パスワード',
          password_confirmation: 'パスワード（確認）',
          reset_password_token: 'パスワードリセット用トークン',
        }
        const errorMessage = Object.entries(e?.response?.data?.errors ?? {})
          .map(([key, value]) => {
            if (!keyNames[key]) return null
            return `${keyNames[key]}${value}`
          })
          .filter(Boolean)

        if (errorMessage.length > 0) {
          setErrorMessage(errorMessage)
        } else if (e?.message) {
          setErrorMessage([e.message])
        } else {
          // 意図しないエラーの場合はSentryに送る
          Sentry.captureException(e)
          setErrorMessage(['エラーが発生しました。'])
        }
      }
      setIsLoading(false)
    },
    [],
  )

  return (
    <PasswordResetEdit
      isLoading={isLoading}
      isSend={isSend}
      errorMessages={errorMessages}
      updatePassword={updatePassword}
      {...props}
    />
  )
}

function mapStateToProps(state) {
  return state
}
function mapDispatchToProps(dispatch) {
  const bindActions = { setUIState }
  return { actions: bindActionCreators(bindActions, dispatch) }
}
export default withPage(Container, mapStateToProps, mapDispatchToProps, {})
